import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Page } from "frame/components";

const useStyles = makeStyles((theme) => ({
	root: {},
	heading: {
		fontWeight: "bold",
		padding: theme.spacing(2, 0, 1.5, 0),
		marginTop: theme.spacing(4),
		textAlign: "center",
		fontSize: `calc(${theme.typography.h3.fontSize} * 1.6)`,
		lineHeight: 1.1,
		marginBottom: theme.spacing(3),
		[theme.breakpoints.down("sm")]: {
			fontSize: `calc(${theme.typography.h4.fontSize} * 1.6)`
		}
	},
	linkButton: {
		"padding": theme.spacing(1, 8),
		"color": theme.palette.text.secondary,
		"fontWeight": 600,
		"&:hover": {
			color: theme.palette.brand
		},
		[theme.breakpoints.down("lg")]: {
			padding: theme.spacing(1, 4)
		},
		[theme.breakpoints.down("md")]: {
			padding: theme.spacing(1, 2)
		},
		[theme.breakpoints.down("sm")]: {
			width: "100%"
		}
	},
	inlineLabel: {
		fontWeight: "bold",
		display: "inline-block",
		marginTop: theme.spacing(3),
		color: "#1c2b4a",
		letterSpacing: 0.1,
		[theme.breakpoints.down("xs")]: {
			marginTop: theme.spacing(2),
			fontSize: "1rem"
		}
	},
	inlineNote: {
		display: "inline"
	}
}));

export const Home = () => {
    const classes = useStyles();
    return (
        <Page className={classes.root} title={null}>
        </Page>
    );
};
